import React, { useState, useEffect, useCallback } from 'react';
import OpeningLab from './OpeningLab';
import axios from 'axios';
import TrailBActive from './TrailBActive';
import SectorTradeActive from './SectorTradeActive';
import SwingScanActive from './SwingScanActive';
import PreMarketAuto from './PreMarketAuto';
import NewsIntel from './NewsIntel';
import TickMonitor from './TickMonitor';
import KiteConnect from './KiteConnect';
import DataUploadPanel from './DataUploadPanel';
import BrokerUploadPanel from './BrokerUploadPanel';
import StatsPanel from './StatsPanel';
import MomentumIndex from './MomentumIndex';
import MIHedge from './MIHedge';
import FOBook from './FOBook';
import IntraDayOI from './IntraDayOI';
import MarketPulse from './MarketPulse';
import WatchPanel from './WatchPanel';
import AlertBanner from './AlertBanner';
import IDWatch from './IDWatch';
import OpeningDrive from './OpeningDrive';
import NewsManual from './NewsManual';
import IntelligencePanel from './IntelligencePanel';

const API = 'https://aaktradex.in';

const C = {
  green: '#3B6D11', lgreen: '#EAF3DE', bgreen: '#C0DD97',
  amber: '#854F0B', lamber: '#FAEEDA', bamber: '#FAC775',
  red: '#A32D2D', lred: '#FCEBEB', bred: '#F7C1C1',
  blue: '#185FA5', lblue: '#E6F1FB', bblue: '#B5D4F4',
  purple: '#6B21A8', lpurple: '#F3E8FF', bpurple: '#C4B5FD',
};

function Pill({ label, color, bg, border }) {
  return <span style={{ fontSize: 10, fontWeight: 500, padding: '2px 8px', borderRadius: 20, background: bg, color, border: `0.5px solid ${border}` }}>{label}</span>;
}

function ScoreBar({ score }) {
  const color = score >= 80 ? C.green : score >= 70 ? '#639922' : score >= 60 ? C.amber : C.red;
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
      <div style={{ width: 40, height: 3, background: '#E8E6DF', borderRadius: 2, overflow: 'hidden' }}>
        <div style={{ width: `${score}%`, height: 3, background: color, borderRadius: 2 }} />
      </div>
      <span style={{ fontSize: 10, fontWeight: 600, color }}>{score}</span>
    </div>
  );
}

function formatVol(v) {
  if (v >= 10000000) return (v / 10000000).toFixed(1) + 'Cr';
  if (v >= 100000) return (v / 100000).toFixed(1) + 'L';
  if (v >= 1000) return (v / 1000).toFixed(0) + 'K';
  return v;
}

function IndPill({ label, ok, warn }) {
  const color = warn ? C.red : ok ? C.green : C.amber;
  const bg = warn ? C.lred : ok ? C.lgreen : C.lamber;
  const border = warn ? C.bred : ok ? C.bgreen : C.bamber;
  return <span style={{ fontSize: 9, fontWeight: 500, padding: '1px 6px', borderRadius: 10, background: bg, color, border: `0.5px solid ${border}` }}>{label}</span>;
}

function smallBtn(color, bg, border) {
  return { fontSize: 10, padding: '3px 10px', borderRadius: 6, border: `0.5px solid ${border}`, background: bg, color, cursor: 'pointer', fontWeight: 500 };
}

function OrderModal({ signal, onConfirm, onClose }) {
  const [qty, setQty] = React.useState(signal.qty || 1);
  const [price, setPrice] = React.useState(signal.ltp || 0);
  const [slPrice, setSlPrice] = React.useState(signal.sl_price || 0);
  const [targetPrice, setTargetPrice] = React.useState(signal.target_price || 0);
  const [orderType, setOrderType] = React.useState(
    signal.action === 'BUY LIMIT' ? 'LIMIT' : 
    (signal._preCheck && !signal._preCheck.vwap_bounce) ? 'LIMIT' : 'MARKET'
  );
  const [limitSuggested, setLimitSuggested] = React.useState(false);
  
  // Auto-update when pre-order check loads
  React.useEffect(() => {
    if (signal._preCheck && signal._preCheck !== 'loading' && !limitSuggested) {
      if (!signal._preCheck.vwap_bounce && signal._preCheck.go) {
        setOrderType('LIMIT');
        if (signal._preCheck.vwap) setPrice(Math.round(signal._preCheck.vwap * 100) / 100);
        setLimitSuggested(true);
      }
    }
  }, [signal._preCheck]);
  const [product, setProduct] = React.useState('MIS');
  const amount = Math.round((qty || 0) * (orderType === 'LIMIT' ? price : signal.ltp));
  const risk = Math.round((qty || 0) * ((orderType === 'LIMIT' ? price : signal.ltp) - (slPrice || 0)));
  const reward = Math.round((qty || 0) * ((targetPrice || 0) - (orderType === 'LIMIT' ? price : signal.ltp)));
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }} onClick={onClose}>
      <div style={{ background: 'var(--bg1)', borderRadius: 12, padding: 20, width: 420, maxHeight: '90vh', overflowY: 'auto', border: '1px solid var(--border2)' }} onClick={e => e.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12 }}>
          <div><span style={{ fontSize: 18, fontWeight: 700 }}>{signal.ticker}</span><span style={{ fontSize: 12, color: 'var(--t2)', marginLeft: 8 }}>Score {signal.score}</span></div>
          <button onClick={onClose} style={{ fontSize: 18, background: 'none', border: 'none', color: 'var(--t3)', cursor: 'pointer' }}>✕</button>
        </div>
        <div style={{ fontSize: 11, color: 'var(--t2)', marginBottom: 10, padding: '4px 8px', background: 'var(--bg2)', borderRadius: 6 }}>
          LTP ₹{signal.ltp} | Day {signal.change_pct > 0 ? '+' : ''}{signal.change_pct}% | Prev ₹{signal.prev_close} | H ₹{signal.high} L ₹{signal.low}
        </div>
        {signal._preCheck === 'loading' && (
          <div style={{ marginBottom: 10, padding: '8px 10px', borderRadius: 6, background: '#f0f9ff', border: '1px solid #bae6fd', textAlign: 'center' }}>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#0369a1' }}>⏳ Running pre-order check...</div>
            <div style={{ fontSize: 10, color: '#0369a1' }}>Checking 1-min RSI, MACD, VWAP</div>
          </div>
        )}
        {signal._preCheck && signal._preCheck !== 'loading' && (
          <div style={{ marginBottom: 10, padding: '6px 10px', borderRadius: 6, background: signal._preCheck.go ? '#f0fdf4' : '#fef2f2', border: signal._preCheck.go ? '1px solid #86efac' : '1px solid #fca5a5' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontSize: 11, fontWeight: 700, color: signal._preCheck.go ? '#166534' : '#991b1b' }}>
                {signal._preCheck.go ? '✅ Pre-Order Check: GO' : '⚠️ Pre-Order Check: WAIT'}
              </span>
              {signal._preCheck.cache_age != null && <span style={{ fontSize: 9, color: signal._preCheck.cache_age <= 30 ? '#166534' : signal._preCheck.cache_age <= 120 ? '#854d0e' : '#991b1b' }}>
                {signal._preCheck.cache_age <= 30 ? '🟢 Live' : signal._preCheck.cache_age <= 120 ? `🟡 ${signal._preCheck.cache_age}s ago` : '🔴 Daily data'}
              </span>}
            </div>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', fontSize: 10, marginBottom: signal._preCheck.warnings && signal._preCheck.warnings.length > 0 ? 4 : 0 }}>
              {signal._preCheck.rsi_1min != null && <span style={{ padding: '1px 6px', borderRadius: 4, background: signal._preCheck.rsi_1min >= 50 ? '#dcfce7' : '#fee2e2', color: signal._preCheck.rsi_1min >= 50 ? '#166534' : '#991b1b' }}>1m RSI: {signal._preCheck.rsi_1min.toFixed(0)}</span>}
              {signal._preCheck.macd_1min_ok != null && <span style={{ padding: '1px 6px', borderRadius: 4, background: signal._preCheck.macd_1min_ok ? '#dcfce7' : '#fee2e2', color: signal._preCheck.macd_1min_ok ? '#166534' : '#991b1b' }}>1m MACD: {signal._preCheck.macd_1min_ok ? '▲' : '▼'}</span>}
              {signal._preCheck.vwap != null && <span style={{ padding: '1px 6px', borderRadius: 4, background: signal.ltp >= signal._preCheck.vwap ? '#dcfce7' : '#fee2e2', color: signal.ltp >= signal._preCheck.vwap ? '#166534' : '#991b1b' }}>VWAP: ₹{signal._preCheck.vwap.toFixed(0)}</span>}
              {signal._preCheck.rsi_direction && <span style={{ padding: '1px 6px', borderRadius: 4, background: signal._preCheck.rsi_direction === 'rising' ? '#dcfce7' : '#fee2e2', color: signal._preCheck.rsi_direction === 'rising' ? '#166534' : '#991b1b' }}>RSI {signal._preCheck.rsi_direction}</span>}
              {signal._preCheck.vwap_bounce != null && <span style={{ padding: '1px 6px', borderRadius: 4, background: signal._preCheck.vwap_bounce ? '#dcfce7' : '#fef9c3', color: signal._preCheck.vwap_bounce ? '#166534' : '#854d0e' }}>{signal._preCheck.vwap_bounce ? '↗ VWAP Bounce' : '⏸ No Bounce'}</span>}
            </div>
            {signal._preCheck.warnings && signal._preCheck.warnings.length > 0 && (
              <div style={{ fontSize: 10, color: '#991b1b' }}>
                {signal._preCheck.warnings.map(function(w, i) { return <div key={i}>⚠ {w}</div> })}
              </div>
            )}
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 10 }}>
          <div>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>ORDER TYPE</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {['MARKET', 'LIMIT'].map(t => (
                <button key={t} onClick={() => setOrderType(t)} style={{ flex: 1, padding: '5px', fontSize: 11, fontWeight: 600, borderRadius: 6, border: '1px solid ' + (orderType === t ? C.bgreen : 'var(--border2)'), background: orderType === t ? C.lgreen : 'transparent', color: orderType === t ? C.green : 'var(--t2)', cursor: 'pointer' }}>{t}</button>
              ))}
            </div>
          </div>
          <div>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>PRODUCT</div>
            <div style={{ display: 'flex', gap: 4 }}>
              {[['MIS', 'Intraday'], ['CNC', 'Delivery']].map(([v, l]) => (
                <button key={v} onClick={() => setProduct(v)} style={{ flex: 1, padding: '5px', fontSize: 11, fontWeight: 600, borderRadius: 6, border: '1px solid ' + (product === v ? C.bblue : 'var(--border2)'), background: product === v ? C.lblue : 'transparent', color: product === v ? C.blue : 'var(--t2)', cursor: 'pointer' }}>{l}</button>
              ))}
            </div>
          </div>
        </div>
        {orderType === 'LIMIT' && (
          <div style={{ marginBottom: 8 }}>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>LIMIT PRICE</div>
            <input type="number" value={price} onChange={e => setPrice(e.target.value === '' ? '' : Number(e.target.value))} style={{ width: '100%', fontSize: 13, padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border2)', background: 'var(--bg1)', color: 'var(--t1)' }} step="0.05" />
          </div>
        )}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 8, marginBottom: 10 }}>
          <div>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>QUANTITY</div>
            <input type="number" value={qty} onChange={e => setQty(e.target.value === '' ? '' : Math.max(1, Number(e.target.value)))} style={{ width: '100%', fontSize: 13, padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border2)', background: 'var(--bg1)', color: 'var(--t1)' }} min="1" />
          </div>
          <div>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>STOP LOSS</div>
            <input type="number" value={slPrice} onChange={e => setSlPrice(e.target.value === '' ? '' : Number(e.target.value))} style={{ width: '100%', fontSize: 13, padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border2)', background: 'var(--bg1)', color: 'var(--t1)' }} step="0.05" />
          </div>
          <div>
            <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>TARGET</div>
            <input type="number" value={targetPrice} onChange={e => setTargetPrice(e.target.value === '' ? '' : Number(e.target.value))} style={{ width: '100%', fontSize: 13, padding: '5px 8px', borderRadius: 6, border: '1px solid var(--border2)', background: 'var(--bg1)', color: 'var(--t1)' }} step="0.05" />
          </div>
        </div>
        <div style={{ background: 'var(--bg2)', borderRadius: 6, padding: '6px 10px', marginBottom: 10, fontSize: 12 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}><span style={{ color: 'var(--t2)' }}>Amount</span><span style={{ fontWeight: 600 }}>₹{amount.toLocaleString()}</span></div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 2 }}><span style={{ color: 'var(--t2)' }}>Risk</span><span style={{ fontWeight: 600, color: C.red }}>₹{risk.toLocaleString()}</span></div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}><span style={{ color: 'var(--t2)' }}>Reward</span><span style={{ fontWeight: 600, color: C.green }}>₹{reward.toLocaleString()}</span></div>
        </div>
        <button onClick={() => onConfirm({ ticker: signal.ticker, signal_id: signal.id, qty, price: orderType === 'LIMIT' ? price : 0, sl_price: slPrice, target_price: targetPrice, order_type: orderType, product })} style={{ width: '100%', padding: '10px', fontSize: 13, fontWeight: 700, borderRadius: 8, border: '1.5px solid ' + C.bgreen, background: C.lgreen, color: C.green, cursor: 'pointer' }}>
          {orderType === 'MARKET' ? `BUY ${qty} × ${signal.ticker} @ Market` : `BUY ${qty} × ${signal.ticker} Limit ₹${price}`} — ₹{amount.toLocaleString()}
        </button>
        <div style={{ fontSize: 10, color: 'var(--t3)', textAlign: 'center', marginTop: 4 }}>REAL order on Zerodha</div>
      </div>
    </div>
  );
}

function SignalCard({ s, onAction, active }) {
  const chgColor = s.change_pct >= 2 ? C.green : s.change_pct >= 1 ? '#639922' : s.change_pct > 0 ? C.amber : C.red;
  const w52 = s.week52_high && s.week52_low && s.week52_high > s.week52_low ? Math.round(((s.ltp - s.week52_low) / (s.week52_high - s.week52_low)) * 100) : null;
  return (
    <div style={{ padding: '8px', marginBottom: 4, borderRadius: 6, border: '0.5px solid var(--border)', background: 'var(--bg1)', fontSize: 11 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 3 }}>
        <span style={{ fontSize: 12, fontWeight: 700 }}>{s.ticker}</span>
        {s.green_count > 0 && (
          <span title={s.green_signals?.join(', ')} style={{ fontSize: 8, letterSpacing: -2, whiteSpace: 'nowrap', display: 'inline-flex', alignItems: 'center', gap: 0 }}>
            {'🟢'.repeat(Math.min(s.green_count || 0, 7))}
            <span style={{ fontSize: 9, color: 'var(--t3)', marginLeft: 3 }}>{s.green_count}/7</span>
          </span>
        )}
        {s.battle_plan && <span style={{ fontSize: 8, fontWeight: 600, padding: '1px 5px', borderRadius: 4, background: '#fef3c7', color: '#92400e', border: '0.5px solid #fcd34d' }}>📋 Battle Plan</span>}
        <span style={{ fontWeight: 600 }}>₹{s.ltp}</span>
        <span style={{ fontWeight: 600, color: chgColor }}>{s.change_pct > 0 ? '+' : ''}{s.change_pct}%</span>
        <span style={{ color: 'var(--t3)', fontSize: 9 }}>Vol {formatVol(s.volume)}</span>
        <div style={{ marginLeft: 'auto' }}><ScoreBar score={s.score} /></div>
      </div>
      <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginBottom: 3 }}>
        {s.rsi && <IndPill label={`RSI ${s.rsi}`} ok={s.rsi >= 48 && s.rsi <= 72} warn={s.rsi > 72} />}
        {s.macd_status && <IndPill label={`MACD ${s.macd_status}`} ok={s.macd_status === '▲'} />}
        {s.sma_status && <IndPill label={`SMA ${s.sma_status}`} ok={s.sma_status === '▲'} />}
        {s.ema_status && <IndPill label={`EMA ${s.ema_status}`} ok={s.ema_status === '▲'} />}
        {w52 !== null && <IndPill label={`52W ${w52}%`} ok={w52 >= 30 && w52 <= 90} warn={w52 > 95} />}
      </div>
      {s.qty > 0 && s.action !== 'SKIP' && (
        <div style={{ fontSize: 10, color: 'var(--t3)', marginBottom: 3 }}>
          Qty {s.qty} | ₹{s.amount?.toLocaleString()} | SL ₹{s.sl_price} | Tgt ₹{s.target_price} | Risk <span style={{color:C.red}}>₹{s.risk}</span> Rwd <span style={{color:C.green}}>₹{s.reward}</span>
        </div>
      )}
      {s.action_detail && <div style={{ fontSize: 10, color: s.action === 'SKIP' ? '#888780' : C.amber, marginBottom: 3 }}>→ {s.action_detail}</div>}
      {s.status === 'PENDING' && active && s.action !== 'SKIP' && (
        <div style={{ display: 'flex', gap: 3 }}>
          {(s.action === 'BUY MARKET' || s.action === 'BUY LIMIT') && <button onClick={() => onAction(s, 'detail')} style={smallBtn(C.green, C.lgreen, C.bgreen)}>Buy</button>}
          <button onClick={() => onAction(s, 'watch')} style={smallBtn(C.amber, C.lamber, C.bamber)}>Watch</button>
          <button onClick={() => onAction(s, 'skip')} style={smallBtn(C.red, C.lred, C.bred)}>Skip</button>
        </div>
      )}
      {s.status === 'APPROVED' && <Pill label="✓ Placed" color={C.green} bg={C.lgreen} border={C.bgreen} />}
    </div>
  );
}

function PositionCard({ p, onAction }) {
  const pnl = p.pnl || 0;
  const pnlColor = pnl >= 0 ? C.green : C.red;
  const pct = p.pnl_pct || (p.entry_price ? ((pnl / (p.entry_price * (p.quantity || 1))) * 100).toFixed(2) : 0);
  const profitPct = p.entry_price ? (((p.current_price - p.entry_price) / p.entry_price) * 100) : 0;
  const nearTarget = p.target && p.current_price >= p.target * 0.995;
  const nearSL = p.stop_loss && p.current_price <= p.stop_loss * 1.005;
  const product = p.product || 'MIS';
  return (
    <div style={{ padding: '10px', borderRadius: 8, border: `${nearTarget || nearSL ? '2px' : '1px'} solid ${nearTarget ? C.bgreen : nearSL ? C.bred : pnl >= 0 ? C.bgreen : C.bred}`, background: nearTarget ? C.lgreen : nearSL ? C.lred : 'var(--bg1)', display: 'inline-block', minWidth: 280, marginRight: 8 }}>
      {nearTarget && <div style={{ fontSize: 11, fontWeight: 700, color: C.green, marginBottom: 4 }}>🎯 NEAR TARGET — Book profit!</div>}
      {nearSL && !nearTarget && <div style={{ fontSize: 11, fontWeight: 700, color: C.red, marginBottom: 4 }}>⚠️ NEAR SL — Review!</div>}
      {profitPct >= 0.4 && !nearTarget && <div style={{ fontSize: 10, color: C.green, marginBottom: 3 }}>📈 +{profitPct.toFixed(2)}% — Trail SL to lock profit</div>}
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ fontSize: 14, fontWeight: 700 }}>{p.ticker}</span>
        <Pill label={product} color={product === 'CNC' ? C.blue : C.amber} bg={product === 'CNC' ? C.lblue : C.lamber} border={product === 'CNC' ? C.bblue : C.bamber} />
        <span style={{ fontSize: 15, fontWeight: 700, color: pnlColor, marginLeft: 'auto' }}>{pnl >= 0 ? '+' : ''}₹{Math.round(pnl)}</span>
        <span style={{ fontSize: 11, color: pnlColor }}>({pct > 0 ? '+' : ''}{pct}%)</span>
      </div>
      <div style={{ fontSize: 11, color: 'var(--t2)', marginBottom: 4 }}>{p.quantity} qty @ ₹{p.entry_price} | LTP ₹{p.current_price} | SL ₹{p.stop_loss} | Tgt ₹{p.target}</div>
      <div style={{ display: 'flex', gap: 3 }}>
        <button onClick={() => onAction(p, 'trail_sl')} style={smallBtn(C.green, C.lgreen, C.bgreen)}>Trail SL</button>
        <button onClick={() => onAction(p, 'update_sl')} style={smallBtn(C.amber, C.lamber, C.bamber)}>Edit SL</button>
        <button onClick={() => onAction(p, 'hold')} style={smallBtn(C.blue, C.lblue, C.bblue)}>Hold</button>
        {product === 'MIS' && <button onClick={() => onAction(p, 'carry_forward')} style={smallBtn(C.purple, C.lpurple, C.bpurple)}>Carry Fwd</button>}
        <button onClick={() => onAction(p, 'sell')} style={{ ...smallBtn(C.red, C.lred, C.bred), fontWeight: 700 }}>SELL</button>
      </div>
    </div>
  );
}

function LogRow({ log }) {
  const lvlColor = log.level === 'INFO' ? C.green : log.level === 'WARNING' ? C.amber : C.red;
  return (
    <div style={{ display: 'flex', gap: 6, padding: '3px 0', borderBottom: '0.5px solid var(--border)', fontSize: 11 }}>
      <span style={{ color: 'var(--t3)', minWidth: 60 }}>{new Date(log.timestamp + 'Z').toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Asia/Kolkata' })}</span>
      <span style={{ fontWeight: 500, color: lvlColor, minWidth: 35 }}>{log.level === 'WARNING' ? 'WARN' : log.level === 'CRITICAL' ? 'CRIT' : log.level}</span>
      <span style={{ color: 'var(--t2)', flex: 1, lineHeight: 1.3 }}>{log.message}</span>
    </div>
  );
}

function Bucket({ title, icon, count, color, bg, border, desc, children }) {
  return (
    <div style={{ flex: 1, minWidth: 0 }}>
      <div className="card" style={{ height: '100%', borderTop: `3px solid ${border}` }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
          <span style={{ fontSize: 12, fontWeight: 700, color }}>{icon} {title}</span>
          <Pill label={String(count)} color={color} bg={bg} border={border} />
        </div>
        <div style={{ fontSize: 9, color: 'var(--t3)', marginBottom: 6 }}>{desc}</div>
        <div style={{ maxHeight: 400, overflowY: 'auto' }}>{children}</div>
      </div>
    </div>
  );
}

// ── Detail Modal for Buy Confirmation ──
const DetailModal = ({signal, onBuy, onClose, warnings}) => {
  const s = signal;
  const p = s.pivots || {};
  const greens = s.green_signals || [];
  const missingSignals = ['RSI','SMA','MACD','5mRSI','15mMACD','VWAP','VOL'].filter(function(g){ return greens.indexOf(g) === -1; });
  
  return (<div style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.7)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}} onClick={onClose}>
    <div style={{background:'var(--bg)',border:'1px solid var(--bd)',borderRadius:12,padding:20,maxWidth:520,width:'95%',maxHeight:'85vh',overflowY:'auto'}} onClick={e=>e.stopPropagation()}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <span style={{fontSize:18,fontWeight:700}}>{s.ticker}</span>
        <span style={{fontSize:14,color:s.action==='BUY MARKET'?'var(--green)':'var(--blue)',fontWeight:600}}>{s.action}</span>
      </div>
      
      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:12}}>
        <div style={{background:'var(--c2)',padding:8,borderRadius:8}}>
          <div style={{fontSize:10,color:'var(--t3)'}}>LTP</div>
          <div style={{fontSize:16,fontWeight:700}}>₹{s.ltp}</div>
        </div>
        <div style={{background:'var(--c2)',padding:8,borderRadius:8}}>
          <div style={{fontSize:10,color:'var(--t3)'}}>Score</div>
          <div style={{fontSize:16,fontWeight:700}}>{s.score}/100</div>
        </div>
        <div style={{background:'var(--c2)',padding:8,borderRadius:8}}>
          <div style={{fontSize:10,color:'var(--t3)'}}>Day Change</div>
          <div style={{fontSize:16,fontWeight:700,color:s.change_pct>0?'var(--green)':'var(--red)'}}>{s.change_pct>0?'+':''}{s.change_pct?.toFixed(2)}%</div>
        </div>
        <div style={{background:'var(--c2)',padding:8,borderRadius:8}}>
          <div style={{fontSize:10,color:'var(--t3)'}}>52W Position</div>
          <div style={{fontSize:16,fontWeight:700}}>{s.week52_pos || '-'}%</div>
        </div>
      </div>

      {/* Green Signals */}
      <div style={{marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:600,marginBottom:4}}>Signals ({s.green_count}/7)</div>
        <div style={{display:'flex',flexWrap:'wrap',gap:4}}>
          {greens.map(g => <span key={g} style={{background:'#e6f9e6',color:'#1a7a1a',padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:600}}>✅ {g}</span>)}
          {missingSignals.map(g => <span key={g} style={{background:'#fde8e8',color:'#c53030',padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:600}}>❌ {g}</span>)}
        </div>
      </div>

      {/* Pivot Points */}
      {p.pivot && <div style={{marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:600,marginBottom:4}}>Support / Resistance</div>
        <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',gap:2,textAlign:'center'}}>
          <div style={{background:'#fde8e8',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#c53030'}}>S3</div><div style={{fontSize:11,fontWeight:600}}>₹{p.s3}</div></div>
          <div style={{background:'#fde8e8',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#c53030'}}>S2</div><div style={{fontSize:11,fontWeight:600}}>₹{p.s2}</div></div>
          <div style={{background:'#fff3e6',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#c05621'}}>S1</div><div style={{fontSize:11,fontWeight:600}}>₹{p.s1}</div></div>
          <div style={{background:'#e6f0ff',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#2b6cb0'}}>Pivot</div><div style={{fontSize:11,fontWeight:700}}>₹{p.pivot}</div></div>
          <div style={{background:'#e6f9e6',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#1a7a1a'}}>R1</div><div style={{fontSize:11,fontWeight:600}}>₹{p.r1}</div></div>
          <div style={{background:'#e6f9e6',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#1a7a1a'}}>R2</div><div style={{fontSize:11,fontWeight:600}}>₹{p.r2}</div></div>
          <div style={{background:'#e6f9e6',padding:4,borderRadius:4}}><div style={{fontSize:8,color:'#1a7a1a'}}>R3</div><div style={{fontSize:11,fontWeight:600}}>₹{p.r3}</div></div>
        </div>
      </div>}

      {/* Indicators */}
      <div style={{marginBottom:12}}>
        <div style={{fontSize:11,fontWeight:600,marginBottom:4}}>Indicators</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:4,fontSize:11}}>
          <div>RSI (Daily): <b>{s.rsi?.toFixed(1)}</b></div>
          <div>RSI (1min): <b style={{color:(s.rsi_5min||0)>50?'green':'red'}}>{s.rsi_5min?.toFixed(1) || 'N/A'}</b> <span style={{fontSize:9,color:s.rsi_direction==='rising'?'green':s.rsi_direction==='falling'?'red':'gray'}}>{s.rsi_direction==='rising'?'\u2191 Rising':s.rsi_direction==='falling'?'\u2193 Falling':'\u2194 Flat'}</span></div>
          <div>MACD (Daily): <b style={{color:s.macd_ok?'green':'red'}}>{s.macd_ok?'▲ Bullish':'▼ Bearish'}</b></div>
          <div>VWAP: <b style={{color:s.real_vwap && s.ltp > s.real_vwap?'green':'red'}}>₹{s.real_vwap?.toFixed(1) || 'N/A'}</b></div>
          <div>Volume: <b>{s.vol_ratio?.toFixed(1)}x avg</b></div>
          <div>ATR: <b>₹{s.atr?.toFixed(1) || 'N/A'}</b></div>
        </div>
      </div>

      {/* Trade Setup */}
      <div style={{marginBottom:16,background:'var(--c2)',padding:10,borderRadius:8}}>
        <div style={{fontSize:11,fontWeight:600,marginBottom:4}}>Trade Setup</div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:4,fontSize:11}}>
          <div>Qty: <b>{s.qty}</b></div>
          <div>Amount: <b>₹{(s.qty * s.ltp).toLocaleString()}</b></div>
          <div>SL: <b style={{color:'red'}}>₹{s.sl?.toFixed(1)}</b></div>
          <div>Target: <b style={{color:'green'}}>₹{s.target?.toFixed(1)}</b></div>
          <div>Risk: <b style={{color:'red'}}>₹{s.risk?.toFixed(0)}</b></div>
          <div>Reward: <b style={{color:'green'}}>₹{s.reward?.toFixed(0)}</b></div>
        </div>
      </div>

      {/* Action Detail */}
      <div style={{fontSize:11,color:'var(--t3)',marginBottom:12}}>→ {s.action_detail}</div>

      {/* Condition Warnings */}
      {warnings && warnings.length > 0 && <div style={{background:'#fef3c7',border:'1px solid #f59e0b',borderRadius:8,padding:10,marginBottom:8}}>
        <div style={{fontWeight:700,color:'#92400e',fontSize:12,marginBottom:4}}>Wait. Conditions Changed.</div>
        {warnings.map(function(w,i){return <div key={i} style={{fontSize:11,color:'#92400e'}}>{'- '+w}</div>})}
      </div>}
      {/* Buttons */}
      <div style={{display:'flex',gap:8}}>
        {warnings && warnings.length > 0 
          ? <button onClick={function(){onBuy('OVERRIDE')}} style={{flex:1,padding:10,background:'#ef4444',color:'#fff',border:'none',borderRadius:8,fontWeight:700,fontSize:13,cursor:'pointer'}}>Override Buy</button>
          : <button onClick={function(){onBuy('MARKET')}} style={{flex:1,padding:10,background:'#22c55e',color:'#fff',border:'none',borderRadius:8,fontWeight:700,fontSize:13,cursor:'pointer'}}>BUY MARKET</button>}
        <button onClick={()=>onBuy('LIMIT')} style={{flex:1,padding:10,background:'#3b82f6',color:'#fff',border:'none',borderRadius:8,fontWeight:700,fontSize:13,cursor:'pointer'}}>BUY LIMIT</button>
        <button onClick={onClose} style={{flex:1,padding:10,background:'var(--c2)',color:'var(--t1)',border:'1px solid var(--bd)',borderRadius:8,fontWeight:700,fontSize:13,cursor:'pointer'}}>Cancel</button>
      </div>

    </div>
  </div>);
};

// News Intel and My News hidden 25 Sep 2026 to make room for Momentum_Index
// and (later) the F&O paper book. Set true to restore both.
const SHOW_NEWS = false;

function App() {
  const [status, setStatus] = useState({ active: false, paused: false, open_positions: 0, daily_pnl: 0, trades_today: 0, consecutive_losses: 0 });
  const [signals, setSignals] = useState([]);
  const [positions, setPositions] = useState([]);
  const [logs, setLogs] = useState([]);
  const [nifty, setNifty] = useState({ value: 0, change: 0 });
  const [margin, setMargin] = useState({ used: 0, total: 75000 });
  const [time, setTime] = useState(new Date());
  const [showConfig, setShowConfig] = useState(false);
  const [morningWL, setMorningWL] = useState(null);
  const [pmData, setPmData] = useState(null);
  const [pmLoading, setPmLoading] = useState(false);

  const [detailSignal, setDetailSignal] = useState(null);
  const [preCheck, setPreCheck] = useState(null);
  const [watchlist, setWatchlist] = useState([]);
  const [wlInput, setWlInput] = useState('');
  const [wlNote, setWlNote] = useState('');
  const [indStatus, setIndStatus] = useState({ fetched_today: false, total_stocks: 0 });
  const [startLoading, setStartLoading] = useState(false);
  const [orderModal, setOrderModal] = useState(null);
  const [activeTab, setActiveTab] = useState('live');

  // Time-based visibility helpers
  const istHour = new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata', hour: 'numeric', hour12: false });
  const currentHour = parseInt(istHour, 10);
  const showWatchlist = currentHour < 9 || currentHour >= 15; // Before 9 AM or after 3 PM

  const fetchData = useCallback(async () => {
    try {
      const [s, sig, pos, log, nft, bal, wl, ind, kpnl] = await Promise.all([
        axios.get(`${API}/status`), axios.get(`${API}/signals`),
        axios.get(`${API}/positions`).catch(() => ({ data: [] })),
        axios.get(`${API}/logs`).catch(() => ({ data: [] })),
        axios.get(`${API}/nifty`).catch(() => ({ data: { value: 0, change: 0 } })),
        axios.get(`${API}/live-balance`).catch(() => ({ data: { available_margin: 75000, used_margin: 0 } })),
        axios.get(`${API}/watchlist`).catch(() => ({ data: [] })),
        axios.get(`${API}/indicators-status`).catch(() => ({ data: { fetched_today: false, total_stocks: 0 } })),
        axios.get(`${API}/kite-pnl`).catch(() => ({ data: { pnl: 0, trades: 0 } })),
      ]);
      setStatus(s.data); setSignals(sig.data);
      setPositions(Array.isArray(pos.data) ? pos.data : (pos.data?.positions) || []);
      setLogs(Array.isArray(log.data) ? log.data : []);
      if (nft.data?.value) setNifty(nft.data);
      if (bal.data) setMargin({ used: bal.data.used_margin || 0, total: bal.data.available_margin || 75000 });
      setWatchlist(Array.isArray(wl.data) ? wl.data : []);
      if (ind.data) setIndStatus(ind.data);
      if (kpnl.data) { setStatus(prev => ({...prev, daily_pnl: kpnl.data.pnl || 0, trades_today: kpnl.data.trades || 0})); }
      try { const mwl = await axios.get(API+'/morning-watchlist'); if(mwl.data && mwl.data.stocks) setMorningWL(mwl.data); } catch(e) {}
      try { const pm = await axios.get(API+'/premarket-data'); if(pm.data && pm.data.trade_setups) setPmData(pm.data); } catch(e) {}
    } catch (e) { console.error(e); }
  }, []);

  useEffect(() => { fetchData(); const t = setInterval(() => { if (!document.hidden) fetchData(); }, 60000); return () => clearInterval(t); }, [fetchData]);
  useEffect(() => { const t = setInterval(() => setTime(new Date()), 1000); return () => clearInterval(t); }, []);

  const startDay = async () => { setStartLoading(true); try { const r = await axios.post(`${API}/start-day`); if (r.data.status === 'error') alert(r.data.message); } catch(e) { alert('Start failed'); } setStartLoading(false); fetchData(); };
  const pauseDay = async () => { await axios.post(`${API}/pause`).catch(() => {}); fetchData(); };
  const stopDay = async () => { if (window.confirm('Stop trading? Positions stay open.')) { await axios.post(`${API}/stop-trading`); fetchData(); } };
  const runPremarket = async () => {
    setPmLoading(true);
    const fii = prompt('FII net flow today (e.g. +1200 or -800, 0 if unknown):', '0');
    try { const r = await axios.post(API+'/premarket-engine?fii_flow='+(fii||0)); setPmData(r.data); alert('Pre-market engine complete!'); } catch(e) { alert('Engine failed'); }
    setPmLoading(false);
    fetchData();
  };
  const squareOff = async () => { if (window.confirm('SQUARE OFF all positions?')) { await axios.post(`${API}/square-off-all`); fetchData(); } };

  const handleOrderConfirm = async (order) => {
    try {
      const r = await axios.post(`${API}/approve-signal`, { signal_id: order.signal_id, order_type: order.order_type, limit_price: order.price, qty: order.qty, product: order.product, sl_price: order.sl_price, target_price: order.target_price });
      if (r.data.status === 'error') alert(r.data.message); else alert(`✅ ${order.order_type} ${order.qty} × ${order.ticker}`);
    } catch(e) { alert('Order failed: ' + e.message); }
    setOrderModal(null); fetchData();
  };

  const handleSignalAction = async (sig, action) => {
    if (action === 'detail') {
      // Show loading modal immediately, then fetch pre-order check
      sig._preCheck = 'loading';
      setOrderModal({...sig});
      try {
        const check = await axios.post(`${API}/pre-order-check?ticker=${sig.ticker}&price=${sig.ltp}`);
        sig._preCheck = check.data;
      } catch(e) {
        sig._preCheck = null;
      }
      setOrderModal({...sig});
      return;
    }
    if (action === 'buy_market' || action === 'buy_limit') { setOrderModal(sig); return; }
    if (action === 'watch') { await axios.post(`${API}/watchlist/add`, { ticker: sig.ticker, note: `Score ${sig.score}` }).catch(() => {}); await axios.post(`${API}/skip-signal`, { signal_id: sig.id, reason: 'Watching' }).catch(() => {}); }
    if (action === 'skip') { await axios.post(`${API}/skip-signal`, { signal_id: sig.id, reason: 'Manual skip' }).catch(() => {}); }
    fetchData();
  };

  const handlePositionAction = async (pos, action) => {
    if (action === 'sell') { if (window.confirm(`SELL ${pos.ticker}?`)) { await axios.post(`${API}/exit-position`, { ticker: pos.ticker }).catch(() => {}); } }
    else if (action === 'trail_sl') { await axios.get(`${API}/monitor-positions`).catch(() => {}); alert('SL trailed'); }
    else if (action === 'update_sl') { const newSl = prompt(`SL for ${pos.ticker}:`, pos.stop_loss); if (newSl) await axios.post(`${API}/update-sl`, { ticker: pos.ticker, sl_price: Number(newSl) }).catch(() => {}); }
    else if (action === 'carry_forward') { if (window.confirm(`Convert ${pos.ticker} MIS→CNC?`)) { await axios.post(`${API}/carry-forward`, { ticker: pos.ticker }).catch(() => {}); } }
    fetchData();
  };

  const addWatchlist = async () => { if (!wlInput.trim()) return; await axios.post(`${API}/watchlist/add`, { ticker: wlInput.trim(), note: wlNote.trim() }).catch(() => {}); setWlInput(''); setWlNote(''); fetchData(); };
  const removeWatchlist = async (ticker) => { await axios.post(`${API}/watchlist/remove`, { ticker }).catch(() => {}); fetchData(); };

  const dotColor = status.active ? C.green : status.paused ? '#BA7517' : '#888780';
  const stateLabel = status.active ? 'Active' : status.paused ? 'Paused' : 'Stopped';
  const stateColor = status.active ? C.green : status.paused ? C.amber : '#5F5E5A';
  const stateBg = status.active ? C.lgreen : status.paused ? C.lamber : '#F1EFE8';
  const stateBorder = status.active ? C.bgreen : status.paused ? C.bamber : '#D3D1C7';
  const niftyColor = nifty.change >= 0 ? C.green : nifty.change > -1 ? C.amber : C.red;
  const niftyBg = nifty.change >= 0 ? C.lgreen : nifty.change > -1 ? C.lamber : C.lred;
  const niftyBorder = nifty.change >= 0 ? C.bgreen : nifty.change > -1 ? C.bamber : C.bred;

  const tradeNow = signals.filter(s => (s.action === 'TRADE NOW' || s.action === 'BUY MARKET') && s.status === 'PENDING');
  const ready = signals.filter(s => (s.action === 'READY' || s.action === 'BUY LIMIT') && s.status === 'PENDING');
  const settingUp = signals.filter(s => (s.action === 'SETTING UP' || s.action === 'WATCH') && s.status === 'PENDING');
  const monitor = signals.filter(s => (s.action === 'MONITOR' || s.action === 'SKIP') && s.status === 'PENDING');
  const openPos = positions.filter(p => p.status === 'OPEN');
  const closedPos = positions.filter(p => p.status === 'CLOSED');

  const css = `
    :root { --bg1: #ffffff; --bg2: #F5F4EF; --t1: #2C2C2A; --t2: #5F5E5A; --t3: #888780; --border: rgba(0,0,0,0.08); --border2: rgba(0,0,0,0.15); }
    @media (prefers-color-scheme: dark) { :root { --bg1: #1a1a18; --bg2: #2c2c2a; --t1: #f1efe8; --t2: #b4b2a9; --t3: #888780; --border: rgba(255,255,255,0.08); --border2: rgba(255,255,255,0.15); } }
    * { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; background: var(--bg2); color: var(--t1); }
    .card { background: var(--bg1); border: 0.5px solid var(--border); border-radius: 10px; padding: 10px 12px; }
    .btn { font-size: 11px; padding: 5px 12px; border-radius: 7px; border: 0.5px solid var(--border2); background: transparent; color: var(--t1); cursor: pointer; display: inline-flex; align-items: center; gap: 4px; font-weight: 500; }
    .btn:hover { background: var(--bg2); } .btn:disabled { opacity: .4; cursor: not-allowed; }
    input { font-size: 12px; padding: 4px 8px; border-radius: 6px; border: 1px solid var(--border2); background: var(--bg1); color: var(--t1); outline: none; }
    @keyframes pulse { 0%,100%{opacity:1} 50%{opacity:.4} }
    @keyframes glow { 0%,100%{box-shadow: 0 0 4px rgba(59,109,17,0.3)} 50%{box-shadow: 0 0 12px rgba(59,109,17,0.6)} }
    @keyframes tradeGlow { 0%,100%{box-shadow: 0 0 4px rgba(220,38,38,0.2)} 50%{box-shadow: 0 0 16px rgba(220,38,38,0.5)} }
  `;

  return (
    <>
      <style>{css}</style>
      <div style={{ minHeight: '100vh', padding: '8px 12px', background: 'var(--bg2)', maxWidth: 1500, margin: '0 auto' }}>

        {/* TOP BAR */}
        <div className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6, padding: '6px 12px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <div style={{ width: 7, height: 7, borderRadius: '50%', background: dotColor, animation: status.active ? 'pulse 1.5s infinite' : 'none' }} />
            <span style={{ fontSize: 14, fontWeight: 600 }}>AakTradeX</span>
            {indStatus.fetched_today && <Pill label={`${indStatus.total_stocks} ind`} color={C.green} bg={C.lgreen} border={C.bgreen} />}
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 20, background: 'var(--bg2)', color: 'var(--t2)' }}>
              {time.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZone: 'Asia/Kolkata' })}
            </span>
            <KiteConnect />
            <button className="btn" style={{ background: C.lgreen, borderColor: C.bgreen, color: C.green, fontWeight: 600 }} onClick={startDay} disabled={status.active || startLoading}>{startLoading ? '⏳' : '▶ Start'}</button>
            <button className="btn" style={{ background: C.lamber, borderColor: C.bamber, color: C.amber }} onClick={pauseDay} disabled={!status.active}>⏸</button>
            <button className="btn" onClick={stopDay} disabled={!status.active && !status.paused}>⬛ Stop</button>
            <button className="btn" style={{ background: C.lred, borderColor: C.bred, color: C.red, fontWeight: 600 }} onClick={squareOff}>⚠ Sq Off</button>
            <button className="btn" onClick={() => setShowConfig(!showConfig)}>⚙</button>
          </div>
        </div>

        <AlertBanner />

        {/* TAB NAVIGATION */}
        <div style={{
          display: 'flex', gap: 6, marginBottom: 8, padding: '4px 0',
          borderBottom: '1px solid var(--border2)',
        }}>
          <button
            onClick={() => setActiveTab('live')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'live' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'live' ? C.blue : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'live' ? `2px solid ${C.blue}` : '2px solid transparent',
              fontWeight: activeTab === 'live' ? 600 : 500,
              cursor: 'pointer',
            }}
          >Live · IntraDay v1</button>
          <button
            onClick={() => setActiveTab('trailb')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'trailb' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'trailb' ? C.purple : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'trailb' ? `2px solid ${C.purple}` : '2px solid transparent',
              fontWeight: activeTab === 'trailb' ? 600 : 500,
              cursor: 'pointer',
            }}
          >TrailB Active v1.0</button>
          <button
            onClick={() => setActiveTab('sectortrade')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'sectortrade' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'sectortrade' ? '#0D7377' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'sectortrade' ? `2px solid #0D7377` : '2px solid transparent',
              fontWeight: activeTab === 'sectortrade' ? 600 : 500,
              cursor: 'pointer',
            }}
          >SectorTrade v1.0</button>
          <button
            onClick={() => setActiveTab('swingscan')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              background: activeTab === 'swingscan' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'swingscan' ? '#0050b3' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'swingscan' ? `2px solid #0050b3` : '2px solid transparent',
              fontWeight: activeTab === 'swingscan' ? 600 : 500,
              fontSize: 14
            }}
          >
            SwingScan v1.0
          </button>
          <button
            onClick={() => setActiveTab('premarket')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              background: activeTab === 'premarket' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'premarket' ? '#ad4e00' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'premarket' ? `2px solid #ad4e00` : '2px solid transparent',
              fontWeight: activeTab === 'premarket' ? 600 : 500,
              fontSize: 14
            }}
          >
            Pre-market v2.0
          </button>
          {SHOW_NEWS && <button
            onClick={() => setActiveTab('newsintel')}
            style={{
              padding: '10px 20px',
              cursor: 'pointer',
              background: activeTab === 'newsintel' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'newsintel' ? '#1d39c4' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'newsintel' ? `2px solid #1d39c4` : '2px solid transparent',
              fontWeight: activeTab === 'newsintel' ? 600 : 500,
              fontSize: 14
            }}
          >
            News Intel
          </button>}
          <button
            onClick={() => setActiveTab('tickmon')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'tickmon' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'tickmon' ? '#185FA5' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'tickmon' ? `2px solid #185FA5` : '2px solid transparent',
              fontWeight: activeTab === 'tickmon' ? 600 : 500,
              cursor: 'pointer',
            }}
          >Tick Monitor</button>
          <button
            onClick={() => setActiveTab('intelligence')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'intelligence' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'intelligence' ? '#6B21A8' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'intelligence' ? '2px solid #6B21A8' : '2px solid transparent',
              fontWeight: activeTab === 'intelligence' ? 600 : 500,
              cursor: 'pointer',
            }}
          >⚡ Intelligence v1.1</button>
          <button
            onClick={() => setActiveTab('momentumindex')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'momentumindex' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'momentumindex' ? '#531dab' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'momentumindex' ? '2px solid #531dab' : '2px solid transparent',
              fontWeight: activeTab === 'momentumindex' ? 600 : 500,
              cursor: 'pointer',
            }}
          >Momentum_Index v1.0</button>
          <button
            onClick={() => setActiveTab('idoi')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'idoi' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'idoi' ? '#534AB7' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'idoi' ? '2px solid #534AB7' : '2px solid transparent',
              fontWeight: activeTab === 'idoi' ? 600 : 500,
              cursor: 'pointer',
            }}
          >IntraDay OI</button>
          <button
            onClick={() => setActiveTab('odrv')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'odrv' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'odrv' ? '#534AB7' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'odrv' ? '2px solid #534AB7' : '2px solid transparent',
              fontWeight: activeTab === 'odrv' ? 600 : 500,
              cursor: 'pointer',
            }}
          >Opening Drive</button>
          <button
            onClick={() => setActiveTab('fobook')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'fobook' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'fobook' ? '#ad4e00' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'fobook' ? '2px solid #ad4e00' : '2px solid transparent',
              fontWeight: activeTab === 'fobook' ? 600 : 500,
              cursor: 'pointer',
            }}
          >F&O Paper</button>
          <button
            onClick={() => setActiveTab('stats')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'stats' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'stats' ? '#c41d7f' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'stats' ? '2px solid #c41d7f' : '2px solid transparent',
              fontWeight: activeTab === 'stats' ? 600 : 500,
              cursor: 'pointer',
            }}
          >📊 Stats</button>
          {SHOW_NEWS && <button
            onClick={() => setActiveTab('newsmanual')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'newsmanual' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'newsmanual' ? '#0050b3' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'newsmanual' ? '2px solid #0050b3' : '2px solid transparent',
              fontWeight: activeTab === 'newsmanual' ? 600 : 500,
              cursor: 'pointer',
            }}
          >📝 My News</button>}
          <button
            onClick={() => setActiveTab('settings')}
            style={{
              fontSize: 12, padding: '6px 16px', borderRadius: '6px 6px 0 0',
              background: activeTab === 'settings' ? 'var(--bg1)' : 'transparent',
              color: activeTab === 'settings' ? '#666' : 'var(--t2)',
              border: 'none',
              borderBottom: activeTab === 'settings' ? '2px solid #666' : '2px solid transparent',
              fontWeight: activeTab === 'settings' ? 600 : 500,
              cursor: 'pointer',
            }}
          >⚙ Settings</button>
        </div>


        <MarketPulse />
        {activeTab === 'trailb' && <TrailBActive />}
        {activeTab === 'sectortrade' && <SectorTradeActive />}
        {activeTab === 'swingscan' && <SwingScanActive />}
        {activeTab === 'premarket' && <OpeningLab />}
        {activeTab === 'premarket' && <PreMarketAuto />}
        {activeTab === 'newsintel' && <NewsIntel />}
        {activeTab === 'tickmon' && <TickMonitor />}
        {activeTab === 'intelligence' && <IntelligencePanel />}
        {activeTab === 'momentumindex' && <><MomentumIndex /><MIHedge /></>}
        {activeTab === 'idoi' && <><IntraDayOI /><WatchPanel /></>}
        {activeTab === 'odrv' && <OpeningDrive />}
        {activeTab === 'fobook' && <FOBook />}
        {activeTab === 'stats' && <StatsPanel />}
        {activeTab === 'newsmanual' && <NewsManual />}
        {activeTab === 'settings' && (
          <>
            <DataUploadPanel />
            <div style={{ padding: '0 16px 24px' }}><BrokerUploadPanel /></div>
          </>
        )}
        {activeTab === 'live' && (<>

        {/* NIFTY + METRICS */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 6 }}>
          <div style={{ flex: 1, padding: '6px 12px', borderRadius: 7, background: niftyBg, border: `0.5px solid ${niftyBorder}`, fontSize: 12 }}>
            <span style={{ fontWeight: 600, color: niftyColor }}>Nifty {nifty.value ? nifty.value.toLocaleString() : '—'} ({nifty.change > 0 ? '+' : ''}{nifty.change}%)</span>
            <span style={{ color: niftyColor, marginLeft: 8 }}>{nifty.change <= -2 ? 'NO trades' : nifty.change <= -1 ? 'Caution' : 'All systems go'}</span>
          </div>
          {[
            ['P&L', `${status.daily_pnl >= 0 ? '+' : ''}₹${Math.round(status.daily_pnl)}`, status.daily_pnl >= 0 ? C.green : C.red],
            ['Pos', `${openPos.length}/3`, 'var(--t1)'],
            ['Trades', `${status.trades_today}`, 'var(--t1)'],
            ['Capital', `₹${(margin.total/1000).toFixed(0)}K`, C.blue],
          ].map(([l, v, color]) => (
            <div key={l} style={{ padding: '6px 12px', borderRadius: 7, background: 'var(--bg1)', border: '0.5px solid var(--border)', minWidth: 80 }}>
              <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>{l}</div>
              <div style={{ fontSize: 16, fontWeight: 600, color }}>{v}</div>
            </div>
          ))}
          <div style={{ padding: '6px 12px', borderRadius: 7, background: 'var(--bg1)', border: '0.5px solid var(--border)' }}>
            <div style={{ fontSize: 9, color: 'var(--t3)', textTransform: 'uppercase' }}>Signals</div>
            <div style={{ display: 'flex', gap: 4, marginTop: 2 }}>
              <Pill label={`${tradeNow.length} trade`} color={C.green} bg={C.lgreen} border={C.bgreen} />
              <Pill label={`${ready.length} ready`} color={C.blue} bg={C.lblue} border={C.bblue} />
              <Pill label={`${settingUp.length} setup`} color={C.amber} bg={C.lamber} border={C.bamber} />
              {tradeNow.length > 0 && <span style={{ fontSize: 9, color: C.green }}>Top: {tradeNow[0]?.green_count || 0}/7</span>}
            </div>
          </div>
        </div>

        {/* POSITIONS (full width) */}
        {openPos.length > 0 && (
          <div className="card" style={{ marginBottom: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--t2)', marginBottom: 6 }}>💼 Open Positions</div>
            <div style={{ display: 'flex', overflowX: 'auto' }}>
              {openPos.map(p => <PositionCard key={p.id || p.ticker} p={p} onAction={handlePositionAction} />)}
            </div>
          </div>
        )}

        {/* 4 BUCKETS HORIZONTAL */}
        <div style={{ display: 'flex', gap: 6, marginBottom: 6, alignItems: 'stretch' }}>
          <Bucket title="TRADE NOW" icon="🔥" count={tradeNow.length} color={C.green} bg={C.lgreen} border={C.bgreen} desc="All confirmed — click Buy">
            {tradeNow.length === 0 ? <div style={{ color: 'var(--t3)', fontSize: 11, padding: '16px 0', textAlign: 'center' }}>Waiting for confirmation</div> : tradeNow.map(s => <SignalCard key={s.id} s={s} onAction={handleSignalAction} active={status.active} />)}
          </Bucket>
          <Bucket title="READY" icon="🟢" count={ready.length} color={C.blue} bg={C.lblue} border={C.bblue} desc="Daily setup confirmed — watching timing">
            {ready.length === 0 ? <div style={{ color: 'var(--t3)', fontSize: 11, padding: '16px 0', textAlign: 'center' }}>None</div> : ready.map(s => <SignalCard key={s.id} s={s} onAction={handleSignalAction} active={status.active} />)}
          </Bucket>
          <Bucket title="SETTING UP" icon="🔵" count={settingUp.length} color={C.amber} bg={C.lamber} border={C.bamber} desc="Building momentum — may upgrade">
            {settingUp.length === 0 ? <div style={{ color: 'var(--t3)', fontSize: 11, padding: '16px 0', textAlign: 'center' }}>None</div> : settingUp.map(s => <SignalCard key={s.id} s={s} onAction={handleSignalAction} active={status.active} />)}
          </Bucket>
          <Bucket title="MONITOR" icon="⊘" count={monitor.length} color={'#888780'} bg={'#F1EFE8'} border={'#D3D1C7'} desc="Not tradeable right now">
            {monitor.length === 0 ? <div style={{ color: 'var(--t3)', fontSize: 11, padding: '16px 0', textAlign: 'center' }}>None</div> : monitor.map(s => <SignalCard key={s.id} s={s} onAction={handleSignalAction} active={status.active} />)}
          </Bucket>
        </div>

        {/* MORNING BATTLE PLAN */}
        {pmData && pmData.trade_setups && <div className="card" style={{marginBottom:6}}>
          <div style={{fontSize:13,fontWeight:700,color:'var(--t2)',marginBottom:4}}>Morning Battle Plan <span style={{fontSize:10,color:'var(--t3)',fontWeight:400}}>{pmData.generated_at} | {pmData.total_qualified} qualified | FII: {pmData.fii_flow > 0 ? '+' : ''}{pmData.fii_flow} Cr</span></div>
          
          {pmData.hot_sectors && pmData.hot_sectors.length > 0 && <div style={{marginBottom:8}}>
            <span style={{fontSize:10,fontWeight:600,color:'var(--t2)'}}>Hot Sectors: </span>
            {pmData.hot_sectors.map(function(hs){return <span key={hs.sector} style={{background:'#dcfce7',color:'#166534',padding:'2px 8px',borderRadius:10,fontSize:10,fontWeight:600,marginRight:4}}>{hs.sector} ({hs.green}/{hs.total})</span>})}
          </div>}
          
          <div style={{fontSize:11,fontWeight:600,color:'#166534',marginBottom:4}}>Trade Setups ({pmData.trade_setups.length})</div>
          <div style={{display:'flex',flexWrap:'wrap',gap:6,marginBottom:8}}>
            {pmData.trade_setups.map(function(s){return <div key={s.ticker} style={{background:s.hot_sector?'#f0fdf4':'var(--c2)',border:s.hot_sector?'1px solid #86efac':'1px solid var(--bd)',borderRadius:8,padding:'8px 10px',fontSize:11,minWidth:180,maxWidth:220}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:2}}>
                <div style={{display:'flex',alignItems:'center',gap:4}}>
                  <span style={{fontWeight:700,fontSize:12}}>{s.ticker}</span>
                  {s.live_status === 'firing_now' && <span style={{fontSize:8,fontWeight:600,padding:'1px 5px',borderRadius:4,background:'#dcfce7',color:'#166534',border:'0.5px solid #86efac'}}>🎯 Firing Now</span>}
                  {s.live_status === 'approaching' && <span style={{fontSize:8,fontWeight:600,padding:'1px 5px',borderRadius:4,background:'#dbeafe',color:'#1e40af',border:'0.5px solid #93c5fd'}}>⏳ Approaching</span>}
                  {s.live_status === 'watching' && <span style={{fontSize:8,fontWeight:600,padding:'1px 5px',borderRadius:4,background:'#fef9c3',color:'#854d0e',border:'0.5px solid #fde047'}}>👁 Watching</span>}
                </div>
                <span style={{fontWeight:700,color:'#166534'}}>Score {s.score}</span>
              </div>
              <div style={{color:'var(--t3)',fontSize:9,marginBottom:3}}>{s.reasons.slice(0,3).join(' | ')}</div>
              <div style={{display:'flex',gap:4,flexWrap:'wrap',marginBottom:3}}>
                <span style={{background:s.close_strength>=70?'#dcfce7':'#fef9c3',padding:'1px 5px',borderRadius:4,fontSize:9}}>Close {s.close_strength}%</span>
                {s.vol_trend==='rising' && <span style={{background:'#dcfce7',padding:'1px 5px',borderRadius:4,fontSize:9}}>Vol Rising</span>}
                {s.streak>=2 && <span style={{background:'#dcfce7',padding:'1px 5px',borderRadius:4,fontSize:9}}>{s.streak}d streak</span>}
                {s.fresh_crossover && <span style={{background:'#dbeafe',padding:'1px 5px',borderRadius:4,fontSize:9}}>Fresh Cross</span>}
                {s.hot_sector && <span style={{background:'#fce7f3',padding:'1px 5px',borderRadius:4,fontSize:9}}>Hot Sector</span>}
              </div>
              <div style={{fontSize:10}}>
                <span>Entry Rs {s.entry}</span> | <span style={{color:'red'}}>SL Rs {s.sl}</span> | <span style={{color:'green'}}>Tgt Rs {s.target}</span>
              </div>
              <div style={{fontSize:9,color:'var(--t3)'}}>Qty {s.qty} | Risk Rs {s.risk} | Rwd Rs {s.reward} | R:R {s.rr_ratio}</div>
            </div>})}
          </div>
          

        </div>}
        {/* NEXT DAY WATCHLIST — visible before 9 AM and after 3 PM, merges evening screener + battle plan watch */}
        {showWatchlist && <div className="card" style={{marginBottom:6}}>
          <div style={{fontSize:12,fontWeight:700,color:'var(--t2)',marginBottom:8}}>Next Day Watchlist <span style={{fontSize:10,color:'var(--t3)',fontWeight:400}}>{morningWL ? `${morningWL.generated_at} | ${morningWL.qualified} qualified` : ''}</span></div>
          
          {/* Battle Plan watch stocks — highlighted */}
          {pmData && pmData.watch_list && pmData.watch_list.length > 0 && <div style={{marginBottom:8}}>
            <div style={{fontSize:10,fontWeight:600,color:'#92400e',marginBottom:4}}>From Battle Plan ({pmData.watch_list.length})</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
              {pmData.watch_list.map(function(s){return <div key={'bp-'+s.ticker} style={{background:'#fef9c3',border:'1px solid #fde047',borderRadius:8,padding:'6px 10px',fontSize:11,minWidth:140}}>
                <div style={{display:'flex',alignItems:'center',gap:3}}>
                  <span style={{fontWeight:700}}>{s.ticker}</span>
                  <span style={{color:'var(--t3)',fontSize:9}}>Score {s.score}</span>
                  {s.live_status === 'firing_now' && <span style={{fontSize:7,fontWeight:600,padding:'1px 4px',borderRadius:3,background:'#dcfce7',color:'#166534'}}>🎯</span>}
                  {s.live_status === 'approaching' && <span style={{fontSize:7,fontWeight:600,padding:'1px 4px',borderRadius:3,background:'#dbeafe',color:'#1e40af'}}>⏳</span>}
                </div>
                <div style={{color:'var(--t3)',fontSize:9}}>{s.reasons ? s.reasons.slice(0,2).join(' | ') : ''}</div>
              </div>})}
            </div>
          </div>}
          
          {/* Evening screener stocks */}
          {morningWL && morningWL.stocks && morningWL.stocks.length > 0 && <div>
            <div style={{fontSize:10,fontWeight:600,color:'var(--t2)',marginBottom:4}}>From Evening Screener ({morningWL.stocks.length})</div>
            <div style={{display:'flex',flexWrap:'wrap',gap:6}}>
              {morningWL.stocks.slice(0,15).map(function(s){return <div key={'ev-'+s.ticker} style={{background:'var(--c2)',border:'1px solid var(--bd)',borderRadius:8,padding:'6px 10px',fontSize:11,minWidth:130}}>
                <div style={{fontWeight:700}}>{s.ticker} <span style={{color:s.macd_ok?'#22c55e':'#c05621',fontSize:9}}>{s.macd_ok?'MACD UP':'MACD DN'}</span></div>
                <div style={{color:'var(--t3)',fontSize:10}}>RSI {s.rsi} | 52W {s.w52_pos}% | Score {s.score}</div>
                <div style={{color:'var(--t3)',fontSize:9}}>{s.reasons ? s.reasons.slice(0,2).join(' | ') : ''}</div>
              </div>})}
            </div>
          </div>}
        </div>}
        {/* ACTIVITY + WATCHLIST */}
        <div style={{ display: 'flex', gap: 6 }}>
          <div className="card" style={{ flex: 2 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--t2)', marginBottom: 6 }}>📋 Activity</div>
            <div style={{ maxHeight: 200, overflowY: 'auto' }}>
              {logs.length === 0 ? <div style={{ color: 'var(--t3)', fontSize: 11, padding: '12px 0', textAlign: 'center' }}>No activity</div> : logs.slice(0, 20).map((l, i) => <LogRow key={i} log={l} />)}
            </div>
          </div>
          <div className="card" style={{ flex: 1 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--t2)', marginBottom: 6 }}>★ Watchlist</div>
            <div style={{ display: 'flex', gap: 4, marginBottom: 6 }}>
              <input value={wlInput} onChange={e => setWlInput(e.target.value.toUpperCase())} placeholder="TICKER" style={{ width: 70 }} onKeyDown={e => e.key === 'Enter' && addWatchlist()} />
              <input value={wlNote} onChange={e => setWlNote(e.target.value)} placeholder="Note" style={{ flex: 1 }} onKeyDown={e => e.key === 'Enter' && addWatchlist()} />
              <button className="btn" onClick={addWatchlist} style={{ background: C.lgreen, borderColor: C.bgreen, color: C.green }}>+</button>
            </div>
            {watchlist.map(w => (
              <div key={w.ticker} style={{ display: 'flex', alignItems: 'center', gap: 4, padding: '4px 0', borderBottom: '0.5px solid var(--border)', fontSize: 11 }}>
                <span style={{ fontWeight: 700, minWidth: 70 }}>{w.ticker}</span>
                {w.ltp ? <><span>₹{w.ltp}</span><span style={{ color: (w.change_pct||0) >= 0 ? C.green : C.red }}>{w.change_pct > 0 ? '+' : ''}{w.change_pct}%</span></> : <Pill label="WL" color={C.purple} bg={C.lpurple} border={C.bpurple} />}
                {w.rsi && <span style={{ color: 'var(--t3)', fontSize: 9 }}>RSI {w.rsi}</span>}
                <button onClick={() => removeWatchlist(w.ticker)} style={{ marginLeft: 'auto', ...smallBtn(C.red, C.lred, C.bred), fontSize: 9 }}>✕</button>
              </div>
            ))}
          </div>
        </div>

        {/* CONFIG */}
        {showConfig && (
          <div className="card" style={{ marginTop: 6, fontSize: 12 }}>
            <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
              {[['State', <Pill key="s" label={stateLabel} color={stateColor} bg={stateBg} border={stateBorder} />], ['TRADE', 'READY + intraday ✓'], ['READY', '80+ daily setup'], ['SETUP', '70+ building'], ['MONITOR', '<65 or overbought'], ['SL', 'ATR × 1.5'], ['Auto stop', '3:31 PM'], ['Scanner', '30sec']].map(([l, v]) => (
                <div key={l}><span style={{ color: 'var(--t2)' }}>{l}: </span><span style={{ fontWeight: 500 }}>{v}</span></div>
              ))}
            </div>
          </div>
        )}

        {orderModal && <OrderModal signal={orderModal} onConfirm={handleOrderConfirm} onClose={() => setOrderModal(null)} />}
      </>)}
      </div>
    </>
  );
}

export default App;
